import React, { FC } from 'react';

import clsx from 'clsx';

import extension from '~/services/Extension';

import styles from './styles.module.scss';

type Props = {
  text?: string;
  className?: string;
  onClick?: () => void;
};

const extensionTitle = extension.getTitle();
const extensionUrl = extension.getExtensionUrl();
const ExtensionIcon = extension.getIcon();

const ExtensionBadge: FC<Props> = ({
  text = `${extensionTitle} Extension`,
  className,
  onClick,
}) => {
  return (
    <a
      href={extensionUrl}
      target="_blank"
      className={clsx(styles.extension, className)}
      rel="nofollow"
      onClick={onClick}
    >
      <ExtensionIcon className={styles.extension__icon} />
      <span>{text}</span>
    </a>
  );
};

export default ExtensionBadge;
